import { Cart } from "@omni/types/api/cart/bff/cart.model";
import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { CartImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/cartImpression.trackingInfo";

import { toCartImpressionTrackingInfo } from "../../mappers/cart.mapper";
import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: CartImpressionTrackingInfo) => {
    const event: AnalyticsEvent<CartImpressionTrackingInfo> = {
        event: EventType.CartImpression,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};

export const trackCart = (cart: Cart) => {
    const trackingInfo = toCartImpressionTrackingInfo(cart);

    track(trackingInfo);
};
